export const apiKey = import.meta.env.REACT_APP_BYTESCALE_API_KEY || '';
export const uploadBucket = import.meta.env.REACT_APP_UPLOAD_FOLDER || '';
export const sharedStyles = {
  colors: {
    primary: '#377dff',
  },
};

export const sharedLocale = {
  processingFile: 'Processing file...',
  submitBtnLoading: 'Please wait...',
  addAnotherFileBtn: 'Add another file...',
  addAnotherImageBtn: 'Add another image...',
  maxFilesReachedPrefix: 'Maximum number of files:',
  maxImagesReachedPrefix: 'Maximum number of images:',
  unsupportedFileType: 'File type not supported.',
  fileSizeLimitPrefix: 'File size limit:',
  finishBtn: 'Set image',
  uploadFileBtn: 'Click to open the file browser',
  uploadFileMultiBtn: 'Click to open the file browser',
  uploadImageBtn: 'Click to open the file browser',
  uploadImageMultiBtn: 'Click to open the file browser',
};
